<template>
  <div class="login-box">
    <t-login />
    <div class="login-content">
      <div id="ssoContainer"></div>
    </div>
    <div class="bottom">
      <div>©Terminus Technologies Co., Ltd. All Rights Reserved.</div>
      <div>渝ICP备14002581号 | 渝公网安备 50010302002747号</div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { TLogin } from "@/components/layout";
import sso from "tsl-sso-sdk";
import { setToken } from "@/utils/auth";

export default defineComponent({
  name: "login",
  components: {
    [TLogin.name]: TLogin
  },
  setup() {
    const router = useRouter();
    const attrOptions = reactive({
      // 自定义单点登录功能和样式
      fn: {
        remember: true,
        phone: true,
        forget_password: true
      },
      theme: 1,
      style: {}
    });
    const authOptions = {
      client_id: process.env.VUE_APP_CLIENT_ID, // 当前项目的client id, 一般在环境配置文件中配置VUE_APP_CLIENT_ID
      auth_uri: process.env.VUE_APP_SSO_URL, // 3中配置的单点登录地址
      redirect_uri: process.env.VUE_APP_SSO_REDIRECT_URL // 3中配置的回跳地址
    };
    const renderSSO = () => {
      sso
        .render("ssoContainer", authOptions, attrOptions)
        .then((code) => {
          // const { redirect } = router.currentRoute.value.query;
          return setToken(code).then(() => router.push({ path: "/console" }));
        })
        .catch((e) => {
          console.log(e);
          renderSSO();
        });
    };

    onMounted(() => {
      renderSSO();
    });
  }
});
</script>
<style lang="less" scoped>
.login-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/login.jpg") no-repeat center/100%;
  .login-content {
    height: calc(100% - 128px);
    #ssoContainer {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 440px;
      height: 402px;
      margin: auto;
      margin-left: 50%;
      box-shadow: 0 8px 24px 4px rgba(172, 172, 174, 0.3);
    }
  }

  .bottom {
    margin: auto;
    text-align: center;
    & > div {
      color: #4e5969;
      font-size: 12px;
      line-height: 20px;
    }
    :not(:last-child) {
      margin-bottom: 4px;
    }
  }
}
</style>
